
// Import JS Modules

import { builderDispatch, WebUI } from '../_utils/ui';

// -----------------------------------------------------------
//  App
// -----------------------------------------------------------
const App = {
  order: {
    setProperties(obj) {
      for (const key in obj) {
        App.order[key] = obj[key];
      }

      if (builderDispatch) { builderDispatch.dispatch({ type: WebUI.LOGIN }); }
    },
    logged_in() {
      return !!App.order.logged_in_user_name;
    },
    storage_provider_activated() {
      return !!App.order.storage_provider_present;
    },
  },
};

export default App;
